export default "__VITE_ASSET__gqwtuIfW__"